import { config } from 'src/config';

export function composeSciLink(hash: string): string {
  return `${config.protocol}://www.${config.domain}#${hash}`;
}